import { Select, Loader, Box } from "@mantine/core";
import { useHindcasts } from "../../api/hindcasts";
import { useAppStore } from "../../store/appStore";

export function HindcastSelector() {
  const { data: hindcasts, isLoading } = useHindcasts();
  const { selectedHindcast, setHindcast } = useAppStore();

  const options =
    hindcasts?.map((h) => ({ value: h.name, label: h.name })) ?? [];

  return (
    <Box id="tour-datasource">
      <Select
        placeholder={isLoading ? "Loading…" : "Select a hindcast"}
        data={options}
        value={selectedHindcast}
        onChange={setHindcast}
        disabled={isLoading}
        rightSection={isLoading ? <Loader size="xs" /> : undefined}
        clearable={false}
        searchable
      />
    </Box>
  );
}
